const namespace = {
  header: {
    title: "Get to know the neighborhood",
    description:
      "Explore schools, prices, community vibe, and more before you decide to move.",
  },
  cards: {
    neighborhoodIntel: "Neighborhood Lifestyle Report",
    neighborhoodContext: "Neighborhood Context",
    locationInsights: "Location Insights",
    climateRisk: "Climate Risk",
    communityPortrait: "Community Portrait",
    localMarketOverview: "Local Market Overview",
    marketTrendsReport: "Market Trends Report",
    neighborhoodMarketTrends: "Neighborhood Market Trends",
    realTimeData: "Real-Time Data",
    fiveYearHistoricalView: "5-Year Historical View",
    easyToReadFormat: "Easy-to-Read Format",
    actionableInsights: "Actionable Insights",
  },
  downloadCard: {
    title: "Download your neighborhood report",
    description:
      "Instant insights on local lifestyle, demographics, and market trends.",
    cta: "Get your report",
    select: {
      default: "Select report type",
      niReport: "Neighborhood Lifestyle Report",
      marketReport: "Neighborhood Market Report",
      both: "Both Reports",
    },
  },
  contactInfo: {
    back: "Back",
    title: "Almost there!",
    description:
      "Enter your details to get instant access to your neighborhood report. It’s fast, free, and full of insights.",
    additionalInfo:
      "I agree to receive communications from Local Logic and its real estate partners. I understand that my contact information may be shared with them so they can contact me for marketing or business purposes. I can withdraw my consent at any time. To learn more, please see our <LinkToPrivacyPolicy>Privacy Policy</LinkToPrivacyPolicy>.",
    submit: "Submit",
    confirmationMessage: "All set! We’ve sent your report to {{email}}",
    instructions:
      "Please check your inbox. If you don’t see it within a few minutes, check your spam or junk folder.",
    resendInstructions:
      "Still can’t find it? <resendReport>Click here to resend.</resendReport>",
  },
  initialValues: {
    firstName: "First Name *",
    lastName: "Last Name *",
    email: "Email Address *",
    phone: "Phone Number",
  },
  errors: {
    firstName: "First Name is required",
    lastName: "Last Name is required",
    email: "Email Address is required",
    notValidEmail: "Email Address is not valid",
    privacyCheckbox: "You must agree to the privacy policy",
    phone: "Phone is not a valid number",
  },
} as const;

export default namespace;
